import { createFileRoute } from '@tanstack/react-router'
import LoginPage from '@/components/pages/LoginPage/LoginPage'
import { z } from 'zod'

const loginSearchSchema = z.object({
  error: z.string().optional(),
  user_code: z.string().optional(),
  redirectPage: z.string().optional(),
  redirectUrl: z.string().optional(),
  return_to: z.string().optional(),
})

export const Route = createFileRoute('/login/')({
  validateSearch: (search) => loginSearchSchema.parse(search),
  component: LoginRoute,
})

function LoginRoute() {
  return <LoginPage />
}
